import ScheduleMenuGroup from "@/views/admin/schedule/ScheduleMenuGroup";

export default {
  path: "schedule/menu-group",
  name: "scheduleMenuGroup",
  component: ScheduleMenuGroup,
  meta: {
    requiresAuth: true
  }
};
